<template>
  <div class="wrap-bg">
    <div class="team section-gap">
      <div class="container">
        <div class="section-title-wrapper">
          <div class="fullscreen-row">
            <div class="col-sm-12 mx-auto text-center splash-s splash-container d-flex">
              <h1 class="h1-larger">{{title}}</h1>
              <p class="mb-0 lead">{{content}}</p>
            </div>
          </div>
        </div>
        <div v-if="render" class="row justify-content-center">
          <!-- Team grid  -->
          <div
            class="col-sm-12 col-md-6 col-lg-4 team-list"
            v-for="(content,i) of team.data"
            :key="i"
            data-aos="fade-right" data-aos-duration="2000"
          >
            <div class="card h-100 border-0 border-rad trans">
              <div class="overlay-wrap">
                <img
                  class="img-fluid border-rad w-100"
                  :src="content.image_path"
                  alt="Card image cap"
                  width="370"
                  height="317"
                />
              </div>
              <div class="card-body p-0" id="cardPadding">
                <h4 class="card-title mb-2">{{memberList[i].fields.name}}</h4>
                <span
                  class="role font-italic d-block text-primary"
                >{{memberList[i].fields.position}}</span>
                <p class="card-text mb-3" style="padding-bottom: 10px !important">{{memberList[i].fields.description}}</p>
                <!-- Icons -->
                <ul class="list-inline social-icons-list mb-0 social">
                  <li class="list-inline-item">
                    <a class="font-lg mx-1" :href="memberList[i].fields.facebook" target="_blank" rel="noopener noreferrer">
                      <i class="fab fa-facebook-f" style="color: white"></i>
                    </a>
                    <a class="font-lg mx-1" :href="memberList[i].fields.instagram" target="_blank" rel="noopener noreferrer">
                      <i class="fab fa-instagram social-color"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from "../../utils/api.js";
export default {
  data() {
    return {
      memberList: [],
      render: false,
      title: "",
      content: "",
      team: {
        data: [
          {
            image_path: "static/img/mario_viska.png"
          },
          {
            image_path: "static/img/florian_madlberger.png"
          }
        ]
      }
    };
  },
  mounted() {
    client
      .getEntries({ content_type: "teammember", order: "sys.createdAt" })
      .then(response => {
        this.memberList = [];
        this.memberList = Array.from(response.items);
        this.render = true;
      });
    client
      .getEntries({ content_type: "team", order: "-sys.createdAt" })
      .then(response => {
        this.title = response.items[0].fields.headline;
      });
  }
};
</script>

<style scoped>
.social {
  position: absolute;
  bottom: 10px;

}
.wrap-bg {
  background: url(/static/img/background_muster_10.png);
  background-position: 100% 100%;
  background-size: cover;
  background-attachment: fixed;
}
@media (hover: none) {
  .wrap-bg {
    background-attachment: initial !important;
    background-position: center !important;
  }
}
.border-rad {
  border-radius: 0 !important;
}
h2,
p {
  color: white !important;
}
#cardPadding > span {
  color: #00fbfb !important;
}
.social-color {
  color: #00fbfb !important;
}
#cardPadding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.card-body {
  background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)),
    linear-gradient(white, white);
  /* first bg is on top of this */
}
.card-body > p,
h4,
span,
ul {
  padding: 0 15px !important;
  color: white !important;
}
.h1-larger {
  font-size: 4.5em;
}
h1 {
  color: white !important;
}
.overlay-wrap {
  margin: 0 !important;
}
.trans {
  background-color: transparent;
}
@media screen and (max-width: 600px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: -15% 13%, 70% 40% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 140px, 80px;
    min-height: 200px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1000px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: 10% -20%, 60% 45% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 220px, 90px;
    min-height: 200px;
  }
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .h1-larger {
    font-size: 4.5em !important;
  }
  .row > div > .p-larger {
    font-size: 1.9em !important;
  }
  .fullscreen-row > .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: 5% -50%, 62% 40% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 250px, 110px;
    min-height: 200px;
  }
}
.fullscreen-row {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}
.fullscreen-row:before,
.fullscreen-row:after {
  display: table;
  content: " ";
}
.fullscreen-row:after {
  clear: both;
}
.splash-s {
  background-image: url(/static/img/splash-l.png), url(/static/img/splash-r.png);
  background-position: 6% -58%, 55% 45%;
  background-repeat: no-repeat;
  min-height: 200px;
}
.splash-container {
  justify-content: center;
  align-items: center;
}
</style>